import React, { Suspense, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Switch, useLocation } from 'react-router-dom';

import history from '@authFlow/App/history';
import { ThemeProvider } from '@authFlow/App/Contexts/ThemeContext';
import Layout from '@authFlow/components/Layout/Layout';
import PageLoader from '@authFlow/components/PageLoader';
import { setPage } from '@authFlow/utils/setPage';
import Pages from '@authFlow/App/Routing/Pages';

import type { CustomAuthT } from '@authFlow/types/types';

type Props = {
  auth: CustomAuthT;
  isChina: boolean;
  textCaptchaUrl: string;
  countryCode: string;
  headerTitleLogin?: string;
  signupOfferTitle?: string;
  flowTheme?: string;
};

const AppRoutes = ({ ...props }: Props) => {
  const location = useLocation();

  useEffect(() => {
    const unlisten = history.listen(() => {
      setPage(history?.location?.pathname);
    });
    return unlisten;
  }, []);

  return (
    <>
      <Helmet defaultTitle="Semrush" titleTemplate="%s – Semrush" />
      <ThemeProvider initialFlowTheme={props.flowTheme}>
        <Layout pathname={location.pathname}>
          <Suspense fallback={<PageLoader />}>
            <Switch location={location}>
              <Pages {...props} />
            </Switch>
          </Suspense>
        </Layout>
      </ThemeProvider>
    </>
  );
};

export default AppRoutes;
